/* Warehouse 13 — Creative Director Homepage System (behavior) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initStat(el) {
    var raw = el.getAttribute('data-target') || '';
    var match = raw.match(/[\d,]+(\.\d+)?/);
    if (!match) return;

    var target = parseFloat(match[0].replace(/,/g, ''));
    var prefix = raw.slice(0, match.index);
    var suffix = raw.slice(match.index + match[0].length);
    var hasComma = match[0].indexOf(',') > -1;

    function format(n) {
      var s = Math.round(n).toString();
      if (hasComma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return prefix + s + suffix;
    }

    if (reduceMotion) {
      el.textContent = format(target);
      return;
    }

    var done = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !done) {
            done = true;
            var start = null;
            var duration = 1400;
            function step(ts) {
              if (!start) start = ts;
              var progress = Math.min((ts - start) / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              el.textContent = format(target * eased);
              if (progress < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
  }

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('.w13-stat__num[data-target]'), initStat);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  }
})();
